import {MD_WIDTH} from "@main/helpers/const";

const CARDS_TO_SHOW = 6;
/**
 * Класс для управления блоком с событиями.
 */
export class EventsSection {
    /**
     * Создает экземпляр EventsSection.
     * @param {HTMLElement} el - Элемент секции событий.
     */
    constructor(el) {
        this.el = el;
        this.filterButtons = this.el.querySelectorAll(".js-events-type");
        this.cards = this.el.querySelectorAll(".js-event-card");
        this.descriptionTypes = this.el.querySelectorAll(".js-events-desc");
        this.showMoreButton = this.el.querySelector(".js-btn-show-more");
        this.currentCardCount = CARDS_TO_SHOW;
        this.bindEventListeners();
        this.displayCards("all");
    }

    /**
     * Привязывает обработчики событий к элементам.
     * @returns {void}
     */
    bindEventListeners() {
        document.addEventListener("mouseover", (event) => {
            this.changeCardOnHover(event, "data-bg-hover");
        });

        document.addEventListener("mouseout", (event) => {
            this.changeCardOnHover(event, "data-bg-default");
        });

        this.filterEvents();

        this.showMoreButton.addEventListener("click", () => {
            this.currentCardCount += CARDS_TO_SHOW;
            const activeFilter = document.querySelector(".js-events-type.events__type--active")?.getAttribute("data-type") || "all"; // 
            this.displayCards(activeFilter);
        });
    }

    /**
     * Изменяет фон карточки при наведении.
     * @param {MouseEvent} e - Событие мыши.
     * @param {string} data - Атрибут, содержащий цвет фона.
     * @returns {void}
     */
    changeCardOnHover(e, data) {
        if (e.target.classList.contains("js-event-card") || e.target.closest(".js-event-card")) {
            const card = e.target.classList.contains("js-event-card") ? e.target : e.target.closest(".js-event-card");

            if (card.classList.contains("hover")) {
                card.classList.remove("hover")
            } else {
                card.classList.add("hover")
            }

            const bg = card.getAttribute(data);
            card.style.backgroundColor = bg;
        }
    }

    /**
     * Применяет фильтрацию карточек событий.
     * @returns {void}
     */
    filterEvents() {
        this.filterButtons.forEach(button => {
            button.addEventListener("click", () => {
                const filter = button.getAttribute("data-type");

                this.filterButtons.forEach(btn => btn.classList.remove("events__type--active"));

                button.classList.add("events__type--active");

                this.currentCardCount = CARDS_TO_SHOW;

                if (window.innerWidth >= MD_WIDTH) {
                    this.cards.forEach(card => {
                        if (filter === "all" || card.dataset.type === filter) {
                            card.classList.remove("hidden");
                        } else {
                            card.classList.add("hidden");
                        }
                    });
                } else {
                    this.displayCards(filter);
                }


                this.descriptionTypes.forEach(desc => {
                    if (desc.dataset.activeType === filter) {
                        desc.classList.add("active");
                    } else {
                        desc.classList.remove("active");
                    }
                })
            })
        });
    }

    /**
     * Отображает карточки в зависимости от фильтра.
     * @param {string} filter - Тип фильтра для отображения карточек.
     * @returns {void}
     */
    displayCards(filter) {
        if (window.innerWidth >= MD_WIDTH) return;
        let visibleCards = 0;
        let hiddenCards = [];

        this.cards.forEach(card => {
            if (filter === "all" || card.dataset.type === filter) {
                if (visibleCards < this.currentCardCount) {
                    card.classList.remove("hidden");
                    visibleCards++;
                } else {
                    card.classList.add("hidden");
                    hiddenCards.push(card);
                }
            } else {
                card.classList.add("hidden");
            }
        });

        this.showMoreButton.style.display = visibleCards < this.cards.length && hiddenCards.length > 0 ? "block" : "none";
    }
}

document.querySelectorAll(".js-events-section").forEach(elem => new EventsSection(elem));
